import { createTheme } from '@mui/material/styles';

// Editorial "atelier" palette for the redesigned home — warm paper + ink,
// cyan kept as the interactive accent, coral for warmth. Centralized so every
// home section reads the same tokens.
const ink = '#14181D';
const inkMuted = '#5B6770';
const inkFaint = '#9AA3AB'; // lighter tertiary gray, repeated across placeholder/empty-state text
const inkHover = '#000000';  // was hardcoded '#000' at every hover callsite; same value, single source now
const paper = '#FBF8F4';
const paperDeep = '#F2EBE1';
const cyan = '#1FB6E8';      // slightly deepened from #30C5FF for contrast on paper
const coral = '#FF6A4D';
const coralHover = '#FF5535'; // was hardcoded at every coral-button hover callsite
const cyanHover = '#17a3d1'; // was hardcoded in MentorUpsell's cyan button hover
// Darker variants for any TEXT use (headings, links, button labels) or white-on-fill
// buttons — the bright cyan/coral above fail WCAG AA (2.2-2.8:1) for those contexts.
// Computed to clear 4.5:1 against both Warm Paper and white button text.
const cyanText = '#147696';   // cyan on paper: 4.88:1, white on cyanText: 5.17:1
const coralText = '#B24A35';  // coral on paper: 5.05:1, white on coralText: 5.35:1

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, Arial, sans-serif',
    // Distinctive display serif for editorial headlines.
    display: {
      fontFamily: '"Fraunces", Georgia, serif',
    },
    h1: { fontFamily: '"Fraunces", Georgia, serif', fontWeight: 900, letterSpacing: '-0.02em', lineHeight: 1.02 },
    h2: { fontFamily: '"Fraunces", Georgia, serif', fontWeight: 700, letterSpacing: '-0.015em', lineHeight: 1.08 },
    h3: { fontFamily: '"Fraunces", Georgia, serif', fontWeight: 600, lineHeight: 1.15 },
    overline: { fontFamily: 'Montserrat, sans-serif', fontWeight: 700, letterSpacing: '0.18em', fontSize: '0.72rem' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  palette: {
    primary: { main: cyanText, light: cyan, contrastText: '#ffffff' },
    secondary: { main: coralText, light: coral, contrastText: '#ffffff' },
    text: { primary: ink, secondary: inkMuted },
    background: { default: paper, paper: '#ffffff' },
    grey: { main: '#888888' },
    light_grey: { main: '#dedede' },
  },
  shape: { borderRadius: 14 },
  // Custom design tokens for the home redesign (read via theme.home.*).
  home: {
    ink, inkMuted, inkFaint, inkHover, paper, paperDeep,
    cyan, cyanHover, cyanText, coral, coralHover, coralText,
    display: '"Fraunces", Georgia, serif',
    body: 'Montserrat, sans-serif',
    maxWidth: 1180,
    sectionPy: { xs: 7, md: 12 },
    softShadow: '0 24px 60px -28px rgba(20,24,29,0.28)',
    cardShadow: '0 18px 40px -20px rgba(20,24,29,0.35)',
    grain: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E\")",
  },
});

export default theme;
